// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PageDetailsComponent } from '@client/app/components/pagedetails/details/page-details.component';

@Component({
    selector: 'url-title-page-details',
    standalone: false,
    template: `
        <url-title [title]="title" (goTo)="openPageDetails()" [active]="active" [url]="url"></url-title>
    `,
})
export class UrlTitlePageDetailsComponent implements OnInit {
    @Input() active?: boolean;
    @Input() target: any;
    @Input() subTarget?: any;
    @Input() page: any;
    @Input() title = '';
    @Input() url = '';

    @Output() onClose = new EventEmitter<any>();

    constructor (
        private monEventService: MonEventService,
    ) { }

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.subTarget = this.subTarget || null;
    }

    openPageDetails (): void {
        const params = {
            body: PageDetailsComponent,
            classes: 'page-details-app',
            size: 'page-details',
            data: {
                page: this.page,
                target: this.target,
                subTarget: this.subTarget,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: () => {
            this.onClose.emit();
        } });
    }
}
